'use client';

import React, { createContext, useContext, useMemo, ReactNode } from 'react';

interface PageTranslationContextType {
  translationSlugs: Record<string, string>;
}

const PageTranslationContext = createContext<PageTranslationContextType>({
  translationSlugs: {},
});

export const usePageTranslation = () => useContext(PageTranslationContext);

interface PageTranslationProviderProps {
  children: ReactNode;
  translationSlugs?: Record<string, string>;
}

export const PageTranslationProvider: React.FC<PageTranslationProviderProps> = ({ children, translationSlugs = {} }) => {
  const value = useMemo(() => ({ translationSlugs }), [translationSlugs]);
  return (
    <PageTranslationContext.Provider value={value}>
      {children}
    </PageTranslationContext.Provider>
  );
};